









































































































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import InputField from '@/components/common/inputs/InputField.vue';
import MaskableInput from '@/components/common/inputs/MaskableInput.vue';
import SelectionField from '@/components/common/inputs/SelectionField.vue';
import MappedSelectionField from '@/components/common/inputs/MappedSelectionField.vue';
import Checkbox from '@/components/common/inputs/Checkbox.vue';
import DomainsField from '@/components/common/inputs/DomainsField.vue';
import TextArea from '@/components/common/inputs/TextArea.vue';
import Phases from '@/components/common/inputs/Phases.vue';
import AssociatedPersonsInput from '@/components/details/general-information/AssociatedPersonsInput.vue';
import Well from '@/components/common/Well.vue';
import WellItem from '@/components/common/WellItem.vue';
import FormSection from '@/components/details/FormSection.vue';
import WarningIcon from '@/components/icons/WarningIcon.vue';
import { StatusKeys, StatusLabels } from '@/models/status';
import { VisibilityKeys, VisibilityLabels } from '@/models/visibility';
import { Domain, DomainKeys, DomainLabels } from '@/models/domain';
import { Kle, Form, UserSearchRequest, OrgUnit } from '@/store/modules/commonInterfaces';
import { CommonModule } from '@/store/modules/common';
import { Phase, PhaseKeys } from '@/models/phase';
import InfoTooltip from '@/components/common/InfoTooltip.vue';
import MunicipalityLogo from '@/components/common/MunicipalityLogo.vue';
import StarIcon from '@/components/icons/StarIcon.vue';
import AppDialog from '@/components/common/Dialog.vue';
import DialogContent from '@/components/common/DialogContent.vue';
import Button from '@/components/common/inputs/Button.vue';
import { AuthModule, User } from '@/store/modules/auth';
import { ProcessModule, ProcessState } from '@/store/modules/process';
import { ErrorModule } from '@/store/modules/error';
import DatePicker from '@/components/common/inputs/DatePicker.vue';
import { OrganisationModule } from '@/store/modules/organisation';
// TODO - split this component. No component should be 500 lines
@Component({
  components: {
    InputField,
    Checkbox,
    DomainsField,
    SelectionField,
    InfoTooltip,
    MappedSelectionField,
    StarIcon,
    TextArea,
    MunicipalityLogo,
    Phases,
    AssociatedPersonsInput,
    Well,
    FormSection,
    MaskableInput,
    WellItem,
    WarningIcon,
    AppDialog,
    DialogContent,
    Button,
    DatePicker
  }
})
export default class GeneralInformationForm extends Vue {
  @Prop(Boolean)
  isReporting!: boolean;
  isPhaseChanged = false;
  publicVisibilityDialogOpen = false;
  StatusKeys = StatusKeys;
  PhaseKeys = PhaseKeys;

  visibilityLevels = [
    { value: VisibilityKeys.PERSONAL, text: VisibilityLabels.PERSONAL },
    { value: VisibilityKeys.MUNICIPALITY, text: VisibilityLabels.MUNICIPALITY },
    { value: VisibilityKeys.PUBLIC, text: VisibilityLabels.PUBLIC }
  ];

  statusLevels = [
    { value: StatusKeys.REJECTED, text: StatusLabels.REJECTED },
    { value: StatusKeys.FAILED, text: StatusLabels.FAILED },
    { value: StatusKeys.PENDING, text: StatusLabels.PENDING },
    { value: StatusKeys.INPROGRESS, text: StatusLabels.INPROGRESS },
    { value: StatusKeys.NOT_RATED, text: StatusLabels.NOT_RATED },
    { value: StatusKeys.NOT_RELEVANT, text: StatusLabels.NOT_RELEVANT }
  ];

  get isWithinMunicipality() {
    return AuthModule.user?.cvr === ProcessModule?.cvr;
  }

  get logo() {
    if (this.state.base64Logo != null) {
      return this.state.base64Logo;
    } else {
      return `/logos/${ProcessModule?.cvr}.png`;
    }
  }

  get state() {
    return ProcessModule;
  }

  get common() {
    return CommonModule;
  }

  get canEditOtherContact() {
    if (this.isReporting) {
      if (OrganisationModule.autoOtherContactEmail == null || OrganisationModule.autoOtherContactEmail === "") {
        return true;
      }
      return false;
    } else {
      return ProcessModule.canEditOtherContact;
    }
  }

  get calculatedOtherContact() {
    if (this.isReporting) {
      if (OrganisationModule.autoOtherContactEmail == null || OrganisationModule.autoOtherContactEmail === "") {
        return ProcessModule.otherContactEmail;
      } else {
        return OrganisationModule.autoOtherContactEmail;
      }
    } else {
      return ProcessModule.otherContactEmail;
    }
  }

  assign(state: Partial<ProcessState>) {
    ProcessModule.assign(state);
  }

  update(state: Partial<ProcessState>) {
    ProcessModule.update(state);
  }

  isInErrors(name: string) {
    return ErrorModule.errorInField(ErrorModule.generalInformation, name);
  }

  setKla(kla: string) {
    // Inserts periodes for every 2 characters, to match format: ##.##.##.##.##
    ProcessModule.update({ kla: kla.replace(/(\d{2})(?=\d)/g, '$1.') });
  }

  setKle(kle: Kle) {
    if (!kle) {
      ProcessModule.update({ kle, form: null });
    } else {
      ProcessModule.update({ kle });
    }
    CommonModule.loadFormsByKle(kle);
  }

  kleFilter(item: Kle, queryText: string, itemText: string): boolean {
    return (
      !queryText ||
      item?.code?.toLowerCase().includes(queryText.toLowerCase()) ||
      item?.name?.toLowerCase().includes(queryText.toLowerCase())
    );
  }

  formFilter(item: Form, queryText: string, itemText: string): boolean {
    return (
      !queryText ||
      item?.code?.toLowerCase().includes(queryText.toLowerCase()) ||
      item?.description?.toLowerCase().includes(queryText.toLowerCase())
    );
  }

  phaseChanged(phase: any) {
    this.isPhaseChanged = true;
    ProcessModule.update({ phase });

    if (
      (phase === PhaseKeys.OPERATION || phase === PhaseKeys.DECOMMISSIONED) &&
      ProcessModule.visibility !== VisibilityKeys.PUBLIC
    ) {
      this.openPublicVisibilityDialog();
    }
  }

  search(name: string) {
    const request: UserSearchRequest = { name: `${name}`, cvr: '' };
    if (AuthModule.user) {
      request.cvr = AuthModule.user.cvr;
      CommonModule.searchUsers(request);
    } else {
      CommonModule.searchUsers(request);
    }
  }

  openPublicVisibilityDialog() {
    this.publicVisibilityDialogOpen = true;
  }

  closePublicVisibilityDialog() {
    this.publicVisibilityDialogOpen = false;
  }

  setPublicVisibilityAndCloseDialog() {
    ProcessModule.setVisibility(VisibilityKeys.PUBLIC);
    this.closePublicVisibilityDialog();
  }

  setBookmark(bookmarked: boolean) {
    ProcessModule.setBookmark(bookmarked);
  }
}
